export const FORM_TYPES = [
  {
    id: 'signup',
    description: 'signupDescription'
  },
  {
    id: 'profile',
    description: 'profileDescription'
  },
  {
    id: 'trading',
    description: 'tradingDescription'
  },
  {
    id: 'shipping',
    description: 'shippingDescription'
  },
  {
    id: 'payment',
    description: 'paymentDescription'
  },
  {
    id: 'review',
    description: 'reviewDescription'
  },
  {
    id: 'report',
    description: 'reportDescription'
  },
  {
    id: 'event',
    description: 'eventDescription'
  },
  {
    id: 'error',
    description: 'errorDescription'
  },
  {
    id: 'copyright',
    description: 'copyrightDescription'
  }
]